import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Link and useLocation add karein
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import "./Navbar.css";
import logo from '../../assets/Images/logo1.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [holidayOpen, setHolidayOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const location = useLocation();

  // Hash scroll logic: Jab bhi URL change ho aur usme # ho
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // Thoda delay taaki page load ho jaye
      }
    }
  }, [location]);

  useEffect(() => {
    setIsAnimating(true);
  }, []);

  return (
    <header className={`navbar ${isAnimating ? "animate" : ""}`}>
      <div className="nav-container">
        <div className="logo reveal-left">
          <Link to="/"><img src={logo} alt="Logo" /></Link>
        </div>

        <div className="toggle reveal-left" onClick={() => setMenuOpen(true)}>
          <FaBars />
        </div>

        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <div className="close-btn" onClick={() => { setMenuOpen(false); setHolidayOpen(false); }}>
            <FaTimes />
          </div>

          <li className="reveal-left"><Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link></li>

          <li className="dropdown reveal-left">
            <div className="drop-btn">
              <Link to="/holiday" className="holiday-link">TOURS</Link>
              <FaChevronDown
                className={`drop-arrow ${holidayOpen ? "rotate" : ""}`}
                onClick={(e) => {
                  if (window.innerWidth <= 768) {
                    setHolidayOpen(prev => !prev);
                  }
                }}
              />
            </div>
            <ul className={`drop-menu ${holidayOpen ? "is-open" : ""}`}>
              {/* Ab ye Links sahi se kaam karenge */}
             <li>
  <Link to="/holiday#tour-packages" onClick={() => setMenuOpen(false)}>
    DOMESTIC TOURS
  </Link>
  
</li>
              <li><Link to="/holiday#international-tours" onClick={() => setMenuOpen(false)}>INTERNATIONAL TOURS</Link></li>
              <li><Link to="/holiday#customized-tours" onClick={() => setMenuOpen(false)}>CUSTOMIZED TOURS</Link></li>
              <li><Link to="/holiday#adventure-packages" onClick={() => setMenuOpen(false)}>ADVENTURE & OFFBEAT TOUR</Link></li>
            </ul>
          </li> 

          <li className="reveal-left"><Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US</Link></li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;